import { Stack } from '@mui/material';
import { RiArrowRightLine, RiCheckLine } from '@remixicon/react';
import { Button } from '@upheal/design-system/components/Button/Button';
import { RemixIcon } from '@upheal/design-system/components/Icon/RemixIcon';
import { Typography } from '@upheal/design-system/components/Typography/Typography';
import { trackUiEvent } from '@upheal/shared/utils/analytics/ui-tracking';
import { usePricingUrl } from '../../hooks/usePricingUrl';

const METERED_FEATURES = [
    {
        bold: 'All clinical & practice features',
        rest: ' · No hidden charges',
    },
    {
        bold: 'Unlimited AI Assistant chat',
        rest: ' · Clinical insights and admin tasks',
    },
    {
        bold: 'Billed monthly based on usage',
        rest: ' · No minimum spend',
    },
] as const;

type MeteredFeaturesProps = {
    uiLocation: string;
};

export const MeteredFeatures = ({ uiLocation }: MeteredFeaturesProps) => {
    const { pricingUrl } = usePricingUrl();

    return (
        <>
            {METERED_FEATURES.map((feature) => (
                <Stack
                    key={feature.bold}
                    direction="row"
                    gap={1.25}
                    alignItems="center"
                >
                    <RemixIcon
                        icon={RiCheckLine}
                        size="sm"
                        color="ds.fg.neutral.primary"
                    />
                    <Typography variant="sm">
                        <Typography
                            variant="sm"
                            fontWeight="bold"
                            component="span"
                        >
                            {feature.bold}
                        </Typography>
                        {feature.rest}
                    </Typography>
                </Stack>
            ))}
            <Stack alignItems="center" width="100%">
                <Button
                    variant="ghost"
                    colorScheme="accent1"
                    size="sm"
                    onClick={() => {
                        trackUiEvent(
                            'Click',
                            'Learn More Metered Plan',
                            uiLocation,
                        );
                        window.open(
                            pricingUrl,
                            '_blank',
                            'noopener,noreferrer',
                        );
                    }}
                >
                    <Typography slot="label">Learn more</Typography>
                    <RemixIcon icon={RiArrowRightLine} slot="trailingItem" />
                </Button>
            </Stack>
        </>
    );
};
